var _path, _rect, _rect2, _path2, _rect3, _rect4, _rect5, _rect6, _mask, _path3, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUseTemplate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 130,
    viewBox: "0 0 128 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6592 36.382C37.1488 32.0989 47.2876 32.0356 57.1916 28.0603C67.0778 24.1515 76.7292 16.3305 85.6661 16.2304C94.6874 16.0815 103.127 23.689 104.433 33.4479C105.805 43.2246 100.109 55.1705 101.105 64.4899C102.167 73.8272 110.005 80.4893 111.066 86.9038C112.043 93.367 106.261 99.516 100.279 105.612C94.3157 111.641 88.1704 117.55 81.4912 117.471C74.812 117.392 67.6166 111.258 58.1133 110.28C48.6764 109.32 36.9494 113.448 29.901 110.49C22.9192 107.55 20.6826 97.542 17.5944 87.5193C14.5241 77.4301 10.6509 67.4109 12.0412 58.2318C13.4493 48.9862 20.1875 40.5985 28.6592 36.382Z",
    fill: "#EDCF66",
    fillOpacity: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36.0916,
    y: 53.9263,
    width: 42.9215,
    height: 35.4345,
    rx: 3,
    fill: "white",
    stroke: "#E76058",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 53.0159,
    y: 66.9297,
    width: 6.88519,
    height: 6.88519,
    rx: 3.4426,
    fill: "#E76058"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5733 69.6836L54.3435 77.9458H44.8031L49.5733 69.6836Z",
    fill: "#E76058"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 62.655,
    y: 71.7493,
    width: 8.98429,
    height: 0.748691,
    rx: 0.374345,
    fill: "#E76058"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 62.655,
    y: 73.2466,
    width: 8.98429,
    height: 0.748691,
    rx: 0.374345,
    fill: "#E76058"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 62.655,
    y: 74.7441,
    width: 4.49215,
    height: 0.748691,
    rx: 0.374345,
    fill: "#E76058"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 70.5303,
    y: 37.3079,
    width: 27.9476,
    height: 27.9476,
    rx: 3,
    fill: "white",
    stroke: "#F8D177",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-1_1_16169",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.4989 55.3468C89.2892 54.3112 90.4937 52.3755 90.4937 50.1585C90.4937 46.8505 87.8121 44.1689 84.5042 44.1689C81.1963 44.1689 78.5146 46.8505 78.5146 50.1585C78.5146 52.3754 79.7191 54.311 81.5093 55.3467V56.148C81.5093 57.8019 82.8501 59.1427 84.5041 59.1427C86.1581 59.1427 87.4989 57.8019 87.4989 56.148V55.3468Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4989 55.3468L86.4974 53.6155L85.4989 54.1932V55.3468H87.4989ZM81.5093 55.3467H83.5093V54.1931L82.5108 53.6155L81.5093 55.3467ZM88.4937 50.1585C88.4937 51.6327 87.6952 52.9227 86.4974 53.6155L88.5003 57.078C90.8832 55.6996 92.4937 53.1183 92.4937 50.1585H88.4937ZM84.5042 46.1689C86.7075 46.1689 88.4937 47.9551 88.4937 50.1585H92.4937C92.4937 45.746 88.9167 42.1689 84.5042 42.1689V46.1689ZM80.5146 50.1585C80.5146 47.9551 82.3008 46.1689 84.5042 46.1689V42.1689C80.0917 42.1689 76.5146 45.746 76.5146 50.1585H80.5146ZM82.5108 53.6155C81.3131 52.9226 80.5146 51.6326 80.5146 50.1585H76.5146C76.5146 53.1182 78.1251 55.6994 80.5078 57.0779L82.5108 53.6155ZM83.5093 56.148V55.3467H79.5093V56.148H83.5093ZM84.5041 57.1427C83.9547 57.1427 83.5093 56.6974 83.5093 56.148H79.5093C79.5093 58.9065 81.7456 61.1427 84.5041 61.1427V57.1427ZM85.4989 56.148C85.4989 56.6974 85.0535 57.1427 84.5041 57.1427V61.1427C87.2626 61.1427 89.4989 58.9065 89.4989 56.148H85.4989ZM85.4989 55.3468V56.148H89.4989V55.3468H85.4989Z",
    fill: "#F8D177",
    mask: "url(#path-9-inside-1_1_16169)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 82.258,
    y: 60.6403,
    width: 4.49214,
    height: 1.49738,
    rx: 0.748691,
    stroke: "#F8D177",
    strokeWidth: 1.49738
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 84.1296,
    y: 39.6768,
    width: 0.748691,
    height: 2.99476,
    rx: 0.374345,
    fill: "#C4AC4B"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 91.991,
    y: 50.533,
    width: 0.748691,
    height: 2.99476,
    rx: 0.374345,
    transform: "rotate(-90 91.991 50.533)",
    fill: "#C4AC4B"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 74.0225,
    y: 50.533,
    width: 0.748691,
    height: 2.99476,
    rx: 0.374345,
    transform: "rotate(-90 74.0225 50.533)",
    fill: "#C4AC4B"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 76.3328,
    y: 42.8906,
    width: 0.748691,
    height: 2.24607,
    rx: 0.374345,
    transform: "rotate(-45 76.3328 42.8906)",
    fill: "#C4AC4B"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 91.0874,
    y: 44.4792,
    width: 0.748691,
    height: 2.24607,
    rx: 0.374345,
    transform: "rotate(-135 91.0874 44.4792)",
    fill: "#C4AC4B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseTemplate);
export default __webpack_public_path__ + "static/media/UseTemplate.8a6b9e1c3ea7ab0ee090a675b992461d.svg";
export { ForwardRef as ReactComponent };